module.exports = __webpack_public_path__ + "img/2.6f4187ef.jpg";